// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedReferToCornealVertex_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 6.08296V4H11V6.08296C8.4875 6.50448 6.50448 8.4875 6.08296 11H4V13H6.08296C6.50448 15.5125 8.4875 17.4955 11 17.917V20H13V17.917C15.5125 17.4955 17.4955 15.5125 17.917 13H20V11H17.917C17.4955 8.4875 15.5125 6.50448 13 6.08296ZM11 8.12602C9.59439 8.4878 8.4878 9.59439 8.12602 11H11V8.12602ZM8.12602 13C8.4878 14.4056 9.59439 15.5122 11 15.874V13H8.12602ZM13 15.874C14.4056 15.5122 15.5122 14.4056 15.874 13H13V15.874ZM15.874 11H13V8.12602C14.4056 8.4878 15.5122 9.59439 15.874 11Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedReferToCornealVertex is a generated icon component.
 */
let IconMedReferToCornealVertex = IconMedReferToCornealVertex_1 = class IconMedReferToCornealVertex extends IconBaseElement {
    render() {
        return html `${IconMedReferToCornealVertex_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedReferToCornealVertex.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedReferToCornealVertex = IconMedReferToCornealVertex_1 = __decorate([
    customElement('zui-icon-med-refer-to-corneal-vertex')
], IconMedReferToCornealVertex);
export { IconMedReferToCornealVertex };
